import React from 'react';
import { useQueryClient } from 'react-query';
import {Select, MenuItem, InputLabel} from '@material-ui/core';
import { useAwbStockAllocations } from "../../services/awbStock";  
import _ from "underscore";
import moment from 'moment';

const AwbStockAllocationSelector = props => {

  const queryClient = useQueryClient();
  const extraKeys = [props.companyUuid];
  const records = useAwbStockAllocations({queryClient, useCache: true, extraKeys});  
  const style = props.style || {};
  const {id, label, readOnly, disabled, fullWidth} = props;
  const classNames = [props.className];

  console.log("value: ", props.value);
  if (props.readOnly) {
    classNames.push('readOnly');
  }
  const className = classNames.join(" ");

  const handleChange = event => {    
    if (props.returnType === "object") {
      const returnObject = { value: event.target.value, found: false, data: {}}
      const data = _.findWhere(records.data, { awbAllocationUuid: event.target.value });
      if (data) {
        returnObject.found = true;
        returnObject.data = data;
      }
      props.onChange(returnObject);
    } else {
      props.onChange(event.target.value);
    }
  }

  const renderAwbSerial = (awbSerial) => {
    if (!awbSerial) {
      return ``;
    }
    const serialString = awbSerial.toString().padStart(7, '0');
    const checkValue = parseInt(serialString);
    const checkDigit = checkValue % 7;

    return `${serialString}${checkDigit}`;
  }

  return (
    <div>
      {label?
        <InputLabel shrink id={`${id}-label`}>{label}</InputLabel>
        :<></>
      }
      <Select
        style={{...style}}
        readOnly={readOnly}
        fullWidth={fullWidth}
        className={className}
        value={props.value == null?'':props.value}
        onChange={handleChange}
        renderValue={(value) => {
          const record = _.findWhere(records.data, { awbAllocationUuid: value });
          if (record) {
            return `${moment(record.dateAllocated).format('DD MMM')}${record.airportCode?`(${record.airportCode})`:''}: ${record.awbPrefix}-${renderAwbSerial(record.fromSerial)} to ${record.awbPrefix}-${renderAwbSerial(record.toSerial)} (Qty: ${record.quantity})`;
          } else {
            return value;
          }
        }}
      >
        {(records.data) ?
          records.data.map((record) => {
            return (
              <MenuItem key={record.awbAllocationUuid} value={record.awbAllocationUuid}>{moment(record.dateAllocated).format('DD MMM')}{record.airportCode?`(${record.airportCode})`:''}: {record.awbPrefix}-{renderAwbSerial(record.fromSerial)} to {record.awbPrefix}-{renderAwbSerial(record.toSerial)} (Qty: {record.quantity})</MenuItem>
            );
          }) :
          null
        }
      </Select>
    </div>
  )
}

export default AwbStockAllocationSelector;
